'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const MultipleEmailsIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="MultipleEmailsIcon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        id="Envelope-Postcard--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>Envelope Postcard Streamline Icon: https://streamlinehq.com</desc>
        <defs></defs>
        <title>envelope-postcard</title>
        <path
          d="M2 7.5h20s1.5 0 1.5 1.5v12s0 1.5 -1.5 1.5H2S0.5 22.5 0.5 21V9S0.5 7.5 2 7.5"
          fill="none"
          stroke="#333333"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>

        <path
          d="M20.5 11.5 12 16 3.5 11.5"
          fill="none"
          stroke="#333333"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M3.5 18 7 16"
          fill="none"
          stroke="#333333"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M20.5 18 17 16"
          fill="none"
          stroke="#333333"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>

        <path
          d="m2.5 5.5 19 0"
          fill="none"
          stroke="#333333"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>

        <path
          d="m4.5 3.5 15 0"
          fill="none"
          stroke="#333333"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m6.5 1.5 11 0"
          fill="none"
          stroke="#333333"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

MultipleEmailsIcon.propTypes = {
  sx: PropTypes.object
}
